import { handleUploadFiles } from "../../../redux/user-slices/chat.slice"
import { useDispatch, useSelector } from "react-redux"
import Icons from "../../../assets/js/Icons"
import { useState } from "react"
import { useRef } from "react"

import {
  DialogTitle, DialogContent, DialogActions, Button,
  Grid2 as Grid, Typography, Icon, InputLabel
} from "@mui/material"

function UploadDocuments({ handleClose }) {
  const files = useRef()
  const dispatch = useDispatch()
  const [length, setLength] = useState(0)
  const { data } = useSelector(({ otherSlice }) => otherSlice)

  const handleUpload = async () => {
    const { files: res } = await dispatch(handleUploadFiles({
      files: files.current,
      receiver: data?.specialistId,
    })).unwrap() || {}
    if (res) handleClose()
  }

  const handlePreview = (e) => {
    const selected = Array.from(e.target.files)
    const allowed = ["jpg", "jpeg", "png", "pdf", "doc", "docx"]

    const validFiles = selected.filter((f) => {
      const ext = f.name.split(".").pop().toLowerCase()
      return allowed.includes(ext)
    })

    files.current = validFiles
    setLength(validFiles?.length)
  }

  return (
    <>
      <DialogTitle>Upload Documents</DialogTitle>

      <DialogContent dividers>

        <Grid sx={{ width: "100%", maxWidth: 380 }}>
          <InputLabel
            sx={{
              minHeight: 170,
              borderRadius: "10px",
              border: "1px dashed",
              borderColor: "primary.main",
              display: "grid",
              placeContent: "center",
              textAlign: "center",
              cursor: "pointer",
              bgcolor: "#fafafa",
              "&:hover": { bgcolor: "#f0f8ff" },
            }}
          >
            <Grid>
              <Icon sx={{ fontSize: "60px", color: "primary.main", mb: 1 }}>
                <Icons.UploadSolid />
              </Icon>

              <Typography color="primary.main" fontWeight={600} fontSize={14}>
                Upload PDF / Images / Docs
              </Typography>

              <Typography
                sx={{ fontSize: 12, color: "text.secondary", mt: 1 }}
              >
                Supported: JPG, PNG, PDF, DOC, DOCX
              </Typography>

              {Boolean(length) && (
                <Typography mt={1.5} variant="body2" color="primary">
                  {length} file(s) selected
                </Typography>
              )}
            </Grid>

            <input
              hidden
              multiple
              type="file"
              ref={files}
              onChange={handlePreview}
              accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
            />
          </InputLabel>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleUpload}
          disabled={!Boolean(length)}
        >Upload
        </Button>
      </DialogActions>
    </>
  )
}

export default UploadDocuments
